// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"27f2e1abcbe6e63d","node_modules_canvg_lib_index_es_js":"8a1c0326cbf1cb8a"}[chunkId] + ".js";
};